import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchPipe'
})
export class SearchPipe implements PipeTransform {

  transform(items: any[], filterBy: string): any {

    return filterBy ? (items.filter(item =>
        item.name && item.name.toLowerCase().indexOf(filterBy.toLowerCase()) !== -1)
    ) : items;
  }

}
